import { useDroppable } from "@dnd-kit/core";
import TaskBubble from "@/components/TaskBubble";

export default function InboxBubbles({ tasks, onEdit, onDelete, onSaveAsTemplate, onMoveToQuadrant, onToggleUrgent }) {
  const { setNodeRef, isOver } = useDroppable({ id: "inbox" });

  return (
    <div className="inbox-section">
      <div className="inbox-label">Inbox ({tasks.length})</div>
      <div
        ref={setNodeRef}
        className={`inbox-bubbles ${isOver ? "inbox-drop-active" : ""}`}
        data-testid="inbox-task-bubbles"
        style={{
          minHeight: 60,
          borderRadius: 12,
          border: isOver ? "2px dashed rgba(201, 168, 76, 0.4)" : "2px dashed transparent",
          padding: isOver ? 6 : 0,
          transition: "border-color 0.2s ease, padding 0.2s ease",
          background: isOver ? "rgba(201, 168, 76, 0.04)" : "transparent",
        }}
      >
        {tasks.length === 0 ? (
          <div className="inbox-empty">
            <div className="inbox-empty-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <circle cx="16" cy="16" r="12" stroke="#7A9E7E" strokeWidth="1.5" strokeDasharray="4 3" opacity="0.4" />
                <line x1="16" y1="12" x2="16" y2="20" stroke="#7A9E7E" strokeWidth="1.5" opacity="0.3" />
                <line x1="12" y1="16" x2="20" y2="16" stroke="#7A9E7E" strokeWidth="1.5" opacity="0.3" />
              </svg>
            </div>
            Type above to add tasks
          </div>
        ) : (
          tasks.map((task) => (
            <TaskBubble
              key={task.id}
              task={task}
              onEdit={onEdit}
              onDelete={onDelete}
              onSaveAsTemplate={onSaveAsTemplate}
              onMoveToQuadrant={onMoveToQuadrant}
              onToggleUrgent={onToggleUrgent}
            />
          ))
        )}
      </div>
    </div>
  );
}
